import { useState, useEffect, useCallback } from 'react';

import SchemaService from '@services/schema';
import { executeSort } from '../../../helpers';

export default function useDataGroupsListing(urlCode, budgetHistoryId, budgetOrder) {
  const [budgets, setBudgets] = useState([]);
  const [arrBudgets, setArrBudgets] = useState([]);
  const [isLoadingBudgets, setIsLoadingBudgets] = useState(false);
  const [nextPage, setNextPage] = useState(undefined);
  const [loadingMore, setLoadingMore] = useState(false);

  const handleScrollGetMoreData = useCallback(async () => {
    if (loadingMore) return;

    let nPage = nextPage;

    if (!nPage) {
      nPage = budgets.paging.next;
    }

    setLoadingMore(true);
    const response = await SchemaService.getDataBudgetGroups(urlCode, nPage, budgetHistoryId);

    setArrBudgets([...budgets, ...response.data.data]);
    setNextPage(response && response.data && response.data.paging && response.data.paging.next);
    setLoadingMore(false);
  }, [budgetHistoryId, budgets, loadingMore, nextPage, urlCode]);

  const sortArray = useCallback(() => {
    if (!arrBudgets) return;
    if (!budgetOrder || budgetOrder === 'Ordenar') {
      setBudgets([...arrBudgets]);
      return;
    }

    let sortedBudgets = [...arrBudgets];

    sortedBudgets = sortedBudgets.sort((group1, group2) =>
      executeSort(budgetOrder, group1, group2) ? 1 : -1
    );

    setBudgets(sortedBudgets);
  }, [budgetOrder, arrBudgets]);

  const loadBudgets = useCallback(async () => {
    const getBodySourceIds = (data) => {
      const body = [];

      data.forEach((item) => item.source_id && body.push({ grouped_by: item.source_id }));

      return body;
    };
    const formatDataBudgets = (data, spentData = []) => {
      let newDataFormatted = [...data];

      newDataFormatted = newDataFormatted.map((item) => {
        const newObject = item;

        const spentObject = spentData.find((spentItem) => spentItem.source_id === item.source_id);

        newObject.spend = spentObject && spentObject.spend ? spentObject.spend : 0;

        return newObject;
      });

      return newDataFormatted;
    };
    setIsLoadingBudgets(true);

    const resp = await SchemaService.getDataBudgetGroups(urlCode, '', budgetHistoryId);

    if (resp.status === 200) {
      let respFundings = {};

      if (budgetHistoryId) {
        respFundings = await SchemaService.getFundingsByHistory(urlCode, budgetHistoryId);
      } else {
        respFundings = await SchemaService.getCurrentFundings();
      }

      if (!respFundings.data) {
        setArrBudgets([]);
        setNextPage(undefined);
        setIsLoadingBudgets(false);
        return;
      }

      const {
        end_date: endDate,
        start_date: startDate,
        timezone_offset: timezoneOffset,
      } = respFundings.data;

      const formattedEndDate = endDate.split('T');
      const formattedStartDate = startDate.split('T');

      const respSpendBudget = await SchemaService.getSpendBudget(
        getBodySourceIds(resp.data.data),
        formattedStartDate,
        formattedEndDate,
        timezoneOffset
      );

      setArrBudgets(formatDataBudgets(resp.data.data, respSpendBudget.data.data));
      setNextPage(resp && resp.data.paging && resp.data.paging.next);
    }

    setIsLoadingBudgets(false);
  }, [urlCode, budgetHistoryId]);

  useEffect(() => {
    loadBudgets();
  }, [loadBudgets]);

  useEffect(() => {
    sortArray();
  }, [sortArray]);

  const loadDataGroups = loadBudgets;

  return [budgets, isLoadingBudgets, nextPage, handleScrollGetMoreData, loadDataGroups];
}
